import { createFileRoute } from "@tanstack/react-router";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";

const TITLE = "Impressum, shopify-freelancer.net";
const DESCRIPTION = "Impressum und Anbieterkennzeichnung von shopify-freelancer.net.";

export const Route = createFileRoute("/impressum")({
  component: ImpressumPage,
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { name: "robots", content: "noindex, follow" },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: "https://shopify-freelancer.net/impressum" },
    ],
    links: [{ rel: "canonical", href: "https://shopify-freelancer.net/impressum" }],
  }),
});

function Block({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section className="py-6">
      <h2 className="font-display text-lg font-semibold">{title}</h2>
      <div className="mt-2 space-y-2 text-sm text-muted-foreground">{children}</div>
    </section>
  );
}

function ImpressumPage() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <SiteHeader />
      <main className="mx-auto max-w-3xl px-5 py-16">
        <h1 className="text-3xl font-bold md:text-4xl">Impressum</h1>

        <div className="mt-6 divide-y divide-border/60">
          <Block title="Angaben gemäß § 5 TMG">
            <p>Nicolai Schnepf</p>
            <p>Karlstr. 42</p>
            <p>76133 Karlsruhe</p>
            <p>Deutschland</p>
          </Block>

          <Block title="Kontakt">
            <p>
              E-Mail:{" "}
              <a
                href="mailto:info@shopify-freelancer.net"
                className="text-primary underline underline-offset-4"
              >
                info@shopify-freelancer.net
              </a>
            </p>
            <p>Website: shopify-freelancer.net</p>
          </Block>

          <Block title="Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV">
            <p>Nicolai Schnepf, Karlstr. 42, 76133 Karlsruhe</p>
          </Block>


          <Block title="EU-Streitschlichtung">
            <p>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS)
              bereit:{" "}
              <a
                href="https://ec.europa.eu/consumers/odr/"
                className="text-primary underline underline-offset-4"
                rel="noopener noreferrer"
                target="_blank"
              >
                ec.europa.eu/consumers/odr
              </a>
              . Ich bin nicht bereit und nicht verpflichtet, an Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </Block>

          <Block title="Haftung für Inhalte">
            <p>
              Als Diensteanbieter bin ich für eigene Inhalte auf diesen Seiten nach den allgemeinen
              Gesetzen verantwortlich. Ich bin jedoch nicht verpflichtet, übermittelte oder
              gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die
              auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
          </Block>

          <Block title="Haftung für Links">
            <p>
              Dieses Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte ich
              keinen Einfluss habe. Für die Inhalte der verlinkten Seiten ist stets der jeweilige
              Anbieter oder Betreiber verantwortlich.
            </p>
          </Block>

          <Block title="Urheberrecht">
            <p>
              Die durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten
              unterliegen dem Urheberrecht. Beiträge Dritter sind als solche gekennzeichnet.
            </p>
          </Block>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
